import { IPartListItemBaseDto } from "@/types";

export class EventTrackingService {
  public static trackPageView(pageUrl: string) {
    this.sendAnalyticsCommand(["_trackPageview", pageUrl]);
  }

  public static trackEvent(event: IEventInfo) {
    const { category, action, label, value } = event;

    const args: any[] = ["_trackEvent", category, action, label];

    if (value) {
      args.push(value);
    }

    this.sendAnalyticsCommand(args);
  }

  public static trackOrder(order: IOrderTrackingInfo) {

    const orderId = Array.isArray(order.orderNumbers) ? order.orderNumbers.join(",") : order.orderNumbers;

    const addTransArgs: any[] = [
      "_addTrans",
      orderId,
      order.accountName,
      order.orderTotal,
      order.tax,
      order.shipping,
      order.customerCity,
      order.customerState,
      order.countryCode,
    ];

    this.sendAnalyticsCommand(addTransArgs);

    order.items.forEach((item) => {

      const itemArgs: any[] = [
        "_addItem",
        orderId,
        item.OemPartCode,
        item.PartDescription,
        item.SalesOrganization,
        item.DealerNetPrice,
        item.Quantity,
      ];

      this.sendAnalyticsCommand(itemArgs);

      if (item.CoreCost > 0) {
        const coreArgs: any[] = [
          "_addItem",
          orderId,
          `${item.OemPartCode}-CORE`,
          item.PartDescription,
          item.SalesOrganization,
          item.CoreCost,
          item.Quantity,
        ];

        this.sendAnalyticsCommand(coreArgs);
      }
    });

    this.sendAnalyticsCommand(["_trackTrans"]);
  }

  private static sendAnalyticsCommand(args: any[]) {
    const tracker = (window as any)._gaq as IGoogleAnalyticsLegacyApi;

    if (tracker && typeof tracker.push === "function") {
      tracker.push(args);
    }
  }
}

interface IGoogleAnalyticsLegacyApi {
  /**
   * Executes the given command array, which is simply a JavaScript array that conforms to the following format.
   * The first element of the array must be the name of a tracker object method passed as a string. The rest of the
   * array elements are the values to be passed in as arguments to the function.
   * @see https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApi_gaq
   * @memberof IGoogleAnalyticsLegacyApi
   */
  push: (commandArray: any[]) => void;
}

export interface IEventInfo {
  category: string;
  action: string;
  label: string;
  value?: number;
}

export interface IOrderTrackingInfo {
  orderNumbers: string | string[];
  /**
   * affiliation or store name
   */
  accountName: string;
  orderTotal: number;
  tax: number;
  shipping: number;
  customerCity: string;
  customerState: string;
  countryCode: string;

  items: IPartListItemBaseDto[];
}
